// Kinematics and joint transformation logic
import * as THREE from "three";
import { JointFactory } from "./joints/jointFactory";

// Transform a joint axis by a parent rotation
export function transformAxis(axis, parentRot) {
  const safeAxis = Array.isArray(axis) && axis.length === 3 ? axis : [0, 0, 1];
  const v = new THREE.Vector3(...safeAxis).normalize();
  // Convert from MuJoCo Z-up axis into Three.js Y-up axis (rotate -90deg about X)
  const zUpToYUp = new THREE.Quaternion().setFromEuler(new THREE.Euler(-Math.PI / 2, 0, 0));
  const converted = v.clone().applyQuaternion(zUpToYUp);
  const result = converted.applyQuaternion(parentRot).normalize();
  return result;
}

// Apply joint value to a body group
export function applyJointValue(bodyGroup, joint, value, initialRot, initialPos, parentRot) {
  JointFactory.applyJointValue(bodyGroup, joint, value, initialRot, initialPos, parentRot);
}
